import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { translate, convertToDecimal, convertToSeparator } from '../../../../utils/util';
import { Collapsible, Table } from '../../../../components/UI/ComponentsUI';
import ContainerService from '../../../../services/ContainerService';
import { useEffect, useState } from 'react';

const ExplosionContainerDetail = (props) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        if (props.data.id) {
            props.getContainer({ id: props.data.id }, (response) => {
                response.containerItem.forEach(item => {
                    data.push({
                        partNumber: item.partNumber,
                        partNumberDescription: item.partNumberDescription,
                        idAviexp: item.aviexpId,
                        box: item.baiCode,
                        boxItem: item.baiCodeItem,
                        boxQuantity: item.totalQuantity,
                        orderNumber: item.orderNumber,
                        spawning: item.spawning
                    })
                });
                setData([...data]);
            })
        }

        return () => {
            setData([]);
        }
        // eslint-disable-next-line
    }, [props.data.id]);


    const configItemColumns = () => [
        {
            field: 'partNumber',
            header: translate('container:fields:items:partNumber'),
            align: 'left',
            sortable: false
        },
        {
            field: 'partNumberDescription',
            header: 'Descrição',
            align: 'left',
            sortable: false
        },
        {
            field: 'idAviexp',
            header: "Aviexp",
            align: 'left',
            sortable: false
        },
        {
            field: 'spawning',
            header: "Pago",
            body: (rowData) => {
                return rowData.spawning ? "SIM" : "NÃO"
            },
            align: 'left',
            sortable: false
        },
        {
            field: 'boxQuantity',
            header: translate('container:fields:items:boxQuantity'),
            align: 'left',
            sortable: false
        },
        {
            field: 'orderNumber',
            header: "Pedido Logistico",
            align: 'left',
            sortable: false
        },
        {
            field: 'box',
            header: "Nº Caixa Pai",
            align: 'left',
            sortable: false
        },
        {
            field: 'boxItem',
            header: "Nº Caixa Filho",
            align: 'left',
            sortable: false
        }
    ];

    return (
        <>
            <div className="container-fluid" style={{ marginTop: 5, paddingBlockEnd: '10px' }} >
                <div className="container">
                    <Collapsible
                        id="filterContainer"
                        header={"Container"}
                        body={
                            <div className="row" style={{ marginBottom: '0px' }}>
                                <div className="input-field no-padding col s6">
                                    <b className="field f-1r">{`${translate('container:fields:name')}`}</b>: {`${convertToSeparator(props.data.name) || ''}`}
                                </div>
                                <div className="input-field no-padding col s5">
                                    <span className="field f-1r"><b>{`${translate('container:fields:statusDescription')}`}</b>: {`${convertToDecimal(props.data.statusDescription) || ''}`}</span>
                                </div>
                                <div className="input-field no-padding col s5">
                                    <span className="field f-1r"><b>{`${translate('container:fields:containerTypeName')}`}</b>: {`${convertToDecimal(props.data.containerTypeName) || ''}`}</span>
                                </div>
                                <div className="input-field no-padding col s6">
                                    <span className="field f-1r"><b>{`${translate('container:fields:location')}`}</b>: {`${convertToDecimal(props.data.location) || ''}`}</span>
                                </div>
                                <div className="input-field no-padding col s5">
                                    <span className="field f-1r"><b>{`${translate('container:fields:freeTimeAvailable')}`}</b>: {`${convertToDecimal(props.data.freeTimeAvailable) || ''}`}</span>
                                </div>
                            </div>
                        }
                    />

                    <div className="row" style={{ marginBottom: '5px' }}>
                        <div className="input-field no-padding col s12 container-fluid">
                            <Table
                                col={configItemColumns()}
                                data={data}
                                disablePaged
                            />
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
};

const mapStateToProps = (state) => {
    return {
        item: state.containerReducer.container
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getContainer: (filter, callback) => {
            dispatch(ContainerService.getContainerExplosion(filter, callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ExplosionContainerDetail));

